var a;!function(a){a.heading="collapseHeading",a.wrapper="collapseWrapper",a.card="collapseCard"}(a||(a={}));export{a as CardDataAttributes};
//# sourceMappingURL=Card.types.js.map
